import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './SvgIcon.styles';

const SvgIcon = props => {
  let { value, styles: customStyles, ...rest } = props;
  return (
    <span
      className={`${css(styles.base, styles[value], customStyles)}`}
      {...rest}
    />
  );
};

export default SvgIcon;



// WEBPACK FOOTER //
// ./src/components/common/svgicon/SvgIcon.js